"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-console */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const hooks_1 = require("hooks");
const components_2 = require("../../../../credit_application/components");
const useAdditionalInfoEDS_1 = __importDefault(require("../_hooks/useAdditionalInfoEDS"));
const eds_store_1 = require("../_store/eds.store");
const getSlugs_1 = require("../_utils/getSlugs");
const DisabledEDS_1 = __importDefault(require("../DisabledEDS"));
const AdditionalInfoFormEDS_1 = __importDefault(require("./AdditionalInfoFormEDS"));
function AdditionalInfoEDS() {
    // State
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    // API
    const { postNextLender, patchCreditApplication } = (0, useAdditionalInfoEDS_1.default)();
    // Store
    const { edsEnabled, edsApplicant } = (0, eds_store_1.useEDSStore)();
    // Has Credit Application
    const creditApplicationId = edsApplicant?.creditApplication?.applicationId;
    // Blackbox data
    const blackboxData = getBlackboxData();
    // Funcs
    const handleSubmitCallback = async (data) => {
        if (creditApplicationId) {
            const patchObject = {
                applicationId: creditApplicationId,
                patchConsumerApplicationsV2CreditApplicationsApplicationId: {
                    annualIncome: Number(data.annualIncome),
                    incomeFrequency: data.paymentFrequency,
                    primaryIncomeSource: data.primaryIncomeSource,
                },
            };
            const resp1 = await patchCreditApplication(patchObject);
            if ('data' in resp1) {
                eds_store_1.useEDSStore.setState({
                    edsPersonalInfo: {
                        ...resp1.data,
                    },
                });
            }
            else {
                console.error('Error in resp1:', resp1.error);
            }
            setIsOpen(true);
            const resp2 = await postNextLender({
                applicationId: creditApplicationId,
                postConsumerApplicationsV2PrequalificationsApplicationIdNextLender: {
                    iovationBlackBox: blackboxData.blackbox,
                },
            });
            if (resp2) {
                if ('data' in resp2) {
                    eds_store_1.useEDSStore.setState({
                        edsOffer: {
                            ...resp2.data,
                        },
                    });
                    history.push((0, getSlugs_1.getOfferSlug)());
                }
                else {
                    console.error('Error in resp2:', resp2.error);
                }
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container max-width-800 min-height-600 mar-auto", children: [edsEnabled && ((0, jsx_runtime_1.jsx)("div", { className: "mar-b-40", children: (0, jsx_runtime_1.jsx)(AdditionalInfoFormEDS_1.default, { handleSubmit: handleSubmitCallback }) })), (edsEnabled === null || !creditApplicationId) && ((0, jsx_runtime_1.jsx)("div", { className: "max-width-600 mar-auto text-center", children: (0, jsx_runtime_1.jsxs)(components_1.P, { children: ["Please re-start the application", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, getSlugs_1.getIntroSlug)(), children: "here" }), "."] }) })), edsEnabled === false && (0, jsx_runtime_1.jsx)(DisabledEDS_1.default, {}), (0, jsx_runtime_1.jsx)(components_2.PreparingOfferModal, { isOpen: isOpen, setIsOpen: setIsOpen })] }));
}
exports.default = AdditionalInfoEDS;
